import { useEffect } from "react";
import classes from "./Modal.module.css";
import disableScrolling from "../DisableScrolling/DisableScrolling";

const Modal = (props: {
	children?: JSX.Element;
	visibility: boolean;
	changeVisibility: Function;
	extraStyling?: any;
	closeWrapperStyling?: any;
}) => {
	const [visibility, changeVisibility] = [
		props.visibility,
		props.changeVisibility,
	];

	useEffect(() => {
		disableScrolling(visibility);
	}, [visibility]);

	const modal = visibility ? (
		<>
			<div className={classes.outerWrapper}>
				<div
					className={classes.outerBackground}
					onClick={() => changeVisibility(false)}
				/>
				<div
					className={classes.wrapper}
					style={props.extraStyling ? props.extraStyling : {}}>
					<div
						className={classes.closeModalWrapper}
						style={props.closeWrapperStyling ? props.closeWrapperStyling : {}}>
						<div
							className={classes.closeModal}
							onClick={() => changeVisibility(!visibility)}>
							x
						</div>
					</div>
					{props.children}
				</div>
			</div>
		</>
	) : (
		<></>
	);

	return <>{modal}</>;
};

export default Modal;
